import { Button } from '@chakra-ui/react';
import { Title, WidgetLegend } from '../../Components/Atoms';
import React, { useMemo, useRef } from 'react';
import { ArrowRightIcon } from '../../Assets/images/svgs';
import { useNavigate } from 'react-router-dom';
import PATHS from "../../Routes/paths";
import { Donut } from '../../Components/Organisms/Graphs';
import { MODULE_TYPES } from '../../Library/widgets';
import "./style.css";

const AllDevices = ({ data, enums, label }) => {
  let count = useRef(0);

  const parser = { x: "label", y: "count" };
  const graphData = useMemo(() => {
    count.current = 0;
    return data.map((d) => {
      count.current += d.count || 0;
      const status = enums[d.idx];
      return { label: d.nm, count: d.count, color: status.color };
    });
  }, [ data, enums ]);

  return (
    <main className="widget-section dealers-device-count-widget">
      <div className="widget-chart dealers-device-chart">
        <Donut title="Devices" data={graphData} parser={parser} cutout={68} />
        <p className="widget-chart-icon">
          <span className="devices-count">{count.current}</span>
          <span className="dev-count-label">{label}</span>
        </p>
      </div>
      <div className={`widget-legend device-stats ${graphData.length <= 1 ? "justify-widget-legends" : ""}`}>
        <WidgetLegend sparse data={graphData} parser={parser} showCount={false} showPercent={false} doSort={false} />
      </div>
    </main>
  )
}

const DeviceStats = (stats) => {
  const navigate = useNavigate();
  const dataFor = stats.data[MODULE_TYPES.ALL_DEVICES];
  const { total: totalDevs, installed, stock: inStock } = dataFor;

  const colors = [
    "rgba(253, 160, 20, 1)",
    "rgba(106, 157, 255, 1)",
    "rgba(252, 220, 138, 1)",
    "rgba(168, 252, 138, 1)",
    "rgba(236, 105, 105, 1)",
    "rgba(202, 202, 202, 1)"
  ];

  const mapDevicesToEnum = (devices) =>
    devices.reduce((acc, dev, idx) => {
      acc[dev.idx] = { idx: dev.idx, label: dev.nm, color: colors[idx] };
      return acc;
    }, {});

  const enumsTotal = mapDevicesToEnum(totalDevs);
  const enumsInstalled = mapDevicesToEnum(installed);
  const enumsStock = mapDevicesToEnum(inStock);

  return (
    <div className="widget-group widget-2 dealers-device-count">
      <article className="widget-main">
        <header className="widget-header">
          <Title variant="md" fixed>Dealerships</Title>
        </header>
        <div className="widget-group widget-1">
          <AllDevices label={"All Devices"} title={"Dealerships"} data={totalDevs} enums={enumsTotal} />
          <div className="widget-seperator" />
          <AllDevices label={"In Stock"} data={inStock} enums={enumsStock} />
          <div className="widget-seperator" />
          <AllDevices label={"Installed Devices"} data={installed} enums={enumsInstalled} />
        </div>
      </article>

      <div className="widget-link device-count-widget-link">
        <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(PATHS.SHOW_DEALERS)}>
          View Reports
        </Button>
      </div>
    </div>
  );
}

export default DeviceStats;